/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();


/***Firelight ***/

 document.addEventListener('DOMContentLoaded', function() {

  /*Floating CTA*/
    const header = document.querySelector('#shopify-section-header');
    const productSection = document.querySelector('.product-section');
    const body = document.body;

    if (!productSection) return;

    const scrollShowHide = () => {
      const headerHeight = header ? header.offsetHeight : 0;
      const scrollDistance = productSection.offsetTop + productSection.offsetHeight - headerHeight;

      if (window.scrollY > scrollDistance) {
        body.classList.add('scrolled-past-hero');
      } else {
        body.classList.remove('scrolled-past-hero');
      }
    };

    window.addEventListener('scroll', scrollShowHide, { passive: true });
    scrollShowHide();


    /*Product gallery*/ 
    const $ = window.jQuery;
    if (!$) return;

    const $lightbox = $('.lp-gallery-lightbox');
    const $mainSlider = $('.lp-gallery-lightbox-main-slider');
    const $thumbSlider = $('.lp-gallery-lightbox-thumb-slider');

    $(document).on('click', '.lp-open-gallery-lightbox', function (e) {
      e.preventDefault();
      const startIndex = $(this).data('slide-index') || 0;

      $lightbox.removeClass('hidden').fadeIn(300);
      $('body').css('overflow', 'hidden');

      if (!$mainSlider.hasClass('slick-initialized')) {
        $mainSlider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          fade: true,
          asNavFor: '.lp-gallery-lightbox-thumb-slider',
        });

        $thumbSlider.slick({
          slidesToShow: 8,
          slidesToScroll: 1,
          asNavFor: '.lp-gallery-lightbox-main-slider',
          dots: false,
          centerMode: false,
          focusOnSelect: true,
          arrows: true,
          responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 6 } },
            { breakpoint: 1024, settings: { slidesToShow: 5 } },
          ],
        });
      }

      $mainSlider.slick('slickGoTo', startIndex, true);
      setTimeout(() => {
        $mainSlider.slick('setPosition');
        $thumbSlider.slick('setPosition');
      }, 100);
    });

    function closeLightbox() {
      $lightbox.fadeOut(300, function () {
        $(this).addClass('hidden');
        $('body').css('overflow', '');
      });
    }

    $('.lp-gallery-lightbox-close').on('click', closeLightbox);

    $(document).on('keydown', function (e) {
      if (e.keyCode === 27 && !$lightbox.hasClass('hidden')) closeLightbox();
    });

    $lightbox.on('click', function (e) {
      if ($(e.target).is('.lp-gallery-lightbox, .lp-gallery-lightbox-inner')) {
        closeLightbox();
      }
    });

    $(document).on('click', '.lp-lightbox-zoom', function (e) {
      e.stopPropagation();
    });


    
  });
